import React from "react";
import { DevConfig } from "src/utils/config";
import hotIcon from "src/assets/hot.svg";

interface BlogTableProps {
    contents: {
        blog_id?: string;
        nickname?: string;
        description?: string;
        scrap_cnt?: number;
        recommend?: boolean;
        title?: string;
        scrap_id?: number
    }[];
}

const BlogTable: React.FC<BlogTableProps> = ({ contents }) => {
    const handleLinkClick = (blogUrl: string) => {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        const targetUrl = isMobile ? DevConfig.NAVER_MOBILE + blogUrl : DevConfig.NAVER_WEB + blogUrl;
        
        window.open(targetUrl, "_blank");
    };
    return (
        <div className="table">
            <table className="table table-white table-hover">
                <colgroup>
                    <col style={{width: "15%"}} />
                    <col style={{width: "85%"}} />
                </colgroup>
                <thead>
                    <tr>
                        <th className="text-center text-black3">
                            <p>순위</p>
                        </th>
                        <th className="text-center text-black3">
                            <p>내용</p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {/* <tr 
                        className="highlight"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleLinkClick("/lovefund369")}>
                        <td className="text-center">
                            <small className="text-red fw-semibold p-test">추천</small>
                        </td>
                        <td>
                            <a className="d-flex align-items-center gap-2">
                                <div className="txt">
                                    <small className="fw-semibold ellipsis-box p-test">lovefund이성수 / lovefund이성수의 증시토크</small>
                                </div>
                                <i className="ms-auto me-4"><img className="hot-img" src={hotIcon} alt="" /></i>
                            </a>
                        </td>
                    </tr> */}
                    {contents.filter(content => {
                        return content.recommend !== true;
                    })
                    .map((content, index) => (
                        <tr 
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() => handleLinkClick(`/${content.blog_id}${content.description ? "" : `/${content.scrap_id}`}`)}
                            >
                            <td className="text-center">
                                <small className={`small-test number${index <= 2 ? " bg-red text-white" : ""}`}>{index + 1}</small>
                            </td>
                            <td>
                                {content.description ?
                                    <a className="d-flex align-items-center gap-2">
                                        <div className="txt">
                                            <small className="text-black5 ellipsis-box p-test">{content.nickname} / {content.description}</small>
                                        </div>
                                    </a>:
                                    <a className="d-flex align-items-center gap-2">
                                        <div className="txt">
                                            <small className="text-black5 ellipsis-box p-test">{content.title}</small>
                                        </div>
                                    </a>
                                }
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default BlogTable;